import {useEffect, useMemo, useState} from 'react';

import {assert} from 'Asserts';
import {makeReactContext} from 'lib/makeReactContext';
import {ProcedureAnalysisTemplateConfiguration} from 'procedures/ProcedureDomainTypes';

export interface AnalysisTemplateConfigModalContextProperties {
  fullConfig: ProcedureAnalysisTemplateConfiguration | null;
  setFullConfig: (newConfig: ProcedureAnalysisTemplateConfiguration) => void;
  canSubmit: boolean;
  setCanSubmit: (canSubmit: boolean) => void;
}

const AnalysisTemplateConfigModalContext = makeReactContext<AnalysisTemplateConfigModalContextProperties>(
  () => {
    assert(false, 'This context cannot be skipped');
  },
  'AnalysisTemplateConfigModalContext',
  // Our use of `useMemo` below allows us to use a referential equality check to know whether to re-render
  (context1, context2) => context1 === context2
);

export default AnalysisTemplateConfigModalContext;

/**
 * Acts as a simple host for the state values which are used to hydrate the above context.
 */
export function useAnalysisTemplateConfigModalContext(
  initialConfiguration: ProcedureAnalysisTemplateConfiguration | null
): AnalysisTemplateConfigModalContextProperties {
  const [fullConfig, setFullConfig] = useState<ProcedureAnalysisTemplateConfiguration | null>(
    initialConfiguration
  );
  const [canSubmit, setCanSubmit] = useState(false);

  useEffect(() => {
    setFullConfig(initialConfiguration);
  }, [initialConfiguration]);

  return useMemo(
    () => ({
      fullConfig,
      setFullConfig,
      canSubmit,
      setCanSubmit,
    }),
    [canSubmit, fullConfig]
  );
}
